

import Navigation from '@/components/landing/Navigation';
import Footer from '@/components/landing/Footer';
import { useNavigate } from 'react-router-dom';
import PrivacyPolicy from '@/components/legal/PrivacyPolicy';
import TermsOfService from '@/components/legal/TermsOfService';
import CookiePolicy from '@/components/legal/CookiePolicy';
import EULA from '@/components/legal/EULA';

const Legal = () => {
  const navigate = useNavigate();
  
  // Handle login/signup clicks from the landing page
  const handleLogin = () => {
    navigate('/auth/login');
  };

  const handleSignup = () => {
    navigate('/auth/signup');
  };
  
  return (
    <div className="bg-white min-h-screen">
      <Navigation onLogin={handleLogin} onSignup={handleSignup} />
      
      <div className="container mx-auto px-4 pt-36 pb-12 max-w-4xl">
        <h1 className="text-3xl font-bold mb-8 text-left">Legal Information</h1>
        
        {/* Privacy Policy Section */}
        <PrivacyPolicy />
        
        {/* Terms of Service Section */}
        <TermsOfService />
        
        {/* Cookie Policy Section */}
        <CookiePolicy />
        
        {/* EULA Section */}
        <EULA />
      </div>
      
      <Footer />
    </div>
  );
};

export default Legal;
